import { addAddressLoad } from "../../services/api/match-address";
// import { UPDATE_MY_ADDRESS } from "../mutation-types";

export default async function addAddress({
    state,
    // commit,
    dispatch
}, {name, address, mobile}) {
    const {cId} = state
    await addAddressLoad({cId, name, address, mobile})
    await dispatch('loadMyDetail')
    // commit(UPDATE_MY_ADDRESS, {cId, name, address, mobile})
    return {name, address, mobile}
}
